import React from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/StatusLink.css';

export const STATUS_URL = 'https://status.exxer.com';

// Link único para a página de status, reaproveitado no rodapé, na tela de
// login e no menu de configurações. Abre sempre em nova guia.
const StatusLink = ({ className = '' }) => {
  const { t } = useTranslation('common');
  const label = t('servicesStatus');

  return (
    <a
      href={STATUS_URL}
      className={`status-link${className ? ` ${className}` : ''}`}
      target="_blank"
      rel="noopener noreferrer"
      title={label}
    >
      <svg
        className="status-link-icon"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M2 12h4l2.5-7 4.5 14 2.5-7h6.5" />
      </svg>
      <span>{label}</span>
    </a>
  );
};

export default StatusLink;
